export class Service {  
  static async SendSyllabus(data) {
    // let url = "http://localhost:8080/g2it/training/send-syllabus?";
    let url = "https://backend.gateway2it.com/g2it/training/send-syllabus?";
    try {
      const params = new URLSearchParams();
      params.append('email', data.email);
      params.append('name', data.name);
      const response = await fetch(url + params.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        const result = await response;
        console.log('Success:', result);
      } else {
        console.error('Error:', response.statusText);
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  }
  
  static async TrainingEnquiry(data) {
    // let url = "http://localhost:8080/g2it/training/training-enquiry?";
    let url = "https://backend.gateway2it.com/g2it/training/training-enquiry?";
    try {
      const params = new URLSearchParams();
      params.append('email', data.email);
      params.append('name', data.name);
      params.append('mobileNo', data.number);
      params.append('graduationYear', data.year);
      const response = await fetch(url + params, {        
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        return response.status;
      } else {
        console.error('Error:', response.statusText);
      }
    } catch (error) {
      console.error('Error:', error.message);
    }
  }
  
}